import { GoodReturnStateTypes, GoodReturnActionTypes } from "./GoodReturn.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: GoodReturnStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState(null),
};

const GoodReturnReducer = (
  state: GoodReturnStateTypes = INITIAL_STATE,
  action: any
): GoodReturnStateTypes => {
  switch (action.type) {
    case GoodReturnActionTypes.FETCH_ALL_GOOD_RETURN:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodReturnActionTypes.FETCH_ALL_GOOD_RETURN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case GoodReturnActionTypes.FETCH_ALL_GOOD_RETURN_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodReturnActionTypes.FETCH_ALL_GOOD_RETURN_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // -------------

    case GoodReturnActionTypes.FETCH_ONE_GOOD_RETURN:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: null,
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodReturnActionTypes.FETCH_ONE_GOOD_RETURN_RESET:
      return {
        ...state,
        fetchOne: resetApiCallState(null),
      };
    case GoodReturnActionTypes.FETCH_ONE_GOOD_RETURN_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: null,
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodReturnActionTypes.FETCH_ONE_GOOD_RETURN_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default GoodReturnReducer;
